<template>
  <div class="tariff">
    <div class="tariff__uppertext" v-if="tariff.uppertext" v-html="tariff.uppertext" />
    <div class="tariff__main" :class="{'tariff__main_expanded':!tariff.uppertext}">
      <div class="tariff__headline">
        <div class="tariff__head">
          <div class="tarfiff__head-mobflex">
            <div class="tariff__minitext">тариф</div>
            <div class="tariff__name">{{ tariff.name }}</div>
          </div>
          <div class="tariff__priceblock tariff__priceblock_mob">
            <div class="tariff__oldprice" v-html="tariff.oldprice" />
            <div class="tariff__price" v-html="tariff.price"/>
          </div>
        </div>
        <div class="tariff__icon" v-html="tariff.icon"></div>
        <div class="tariff__radio">
          <slot />
        </div>
      </div>
      <div class="tariff__priceblock">
        <div class="tariff__oldprice" v-html="tariff.oldprice" />
        <div class="tariff__price" v-html="tariff.price"/>
      </div>
    </div>
    <div class="tariff__text" v-html="tariff.text" />
  </div>
</template>

<script>
  export default {
    props: {
      tariff: { type: Object, required: true},
      name: { type: String, default: 'tariff' }
    }
  }
</script>

<style lang="sass">
.tariff
  cursor: pointer
  box-shadow: 0px 20px 40px rgba(52, 53, 64, 0.1)
  border-radius: 8px
  color: colors.$notred
  text-align: center
  transition: background .3s ease-out
  background: colors.$moar_silver_for_the_god_of_silver2
  width: 225px
  &.active
    background: colors.$newred
    .tariff__main
      background: colors.$mainbg
  &__uppertext
    font-weight: 500
    font-size: 16px
    line-height: 1.12
    min-height: 50px
    padding-top: 3px
    display: flex
    align-items: center
    text-align: center
    justify-content: center
    color: colors.$notred
  &__main
    min-height: 342px
    background: colors.$anothersilver
    box-shadow: 0px 20px 40px rgba(52, 53, 64, 0.1)
    border-radius: 8px
    padding: 8px
    &_expanded
      padding: 24px 8px
  &__minitext
    color: colors.$newgray
    font-size: 12px
    line-height: 1.14
    margin-bottom: 2px
  &__radio
    margin-bottom: 16px
    display: flex
    justify-content: center
    input:not(:checked) + .uradio__dot
      border-color: colors.$newgray
  &__name
    margin-bottom: 15px
  &__icon
    margin-bottom: 16px
    svg
      width: 120px
      margin: 0 auto
  &__oldprice
    text-decoration: line-through
    font-size: 14px
    line-height: 1.14
    color: colors.$newgray
    margin-bottom: 1px
  &__price, &__name, &__pricespan
    font-weight: 500
    font-size: 20px
    color: colors.$newred
    line-height: 1.18
  &__pricespan
    color: inherit
  &__text 
    min-height: 90px
    display: flex
    flex-direction: column
    justify-content: center
    color: colors.$notred
    font-weight: 500
    font-size: 16px
    line-height: 1.18
    padding: 16px 8px 8px
  &__priceblock
    &_mob
      display: none
  
  @include from(650px)
    width: 300px
    max-width: 100%
    flex-grow: 1
    &__priceblock
      display: none
      &_mob
        display: block
    &__headline
      display: flex
      align-items: center
      justify-content: flex-start
      text-align: left
      margin-bottom:  0px
    &__minitext
      margin-right: 5px
      padding-bottom: 2px
      margin-bottom: 0
    .tarfiff__head-mobflex
      display: flex
      align-items: center
    &__main
      min-height: initial
      &, &_expanded
        padding: 12px 16px
    &__radio
      order: -2
      margin-right: 10px
    &__icon
      order: -1
      margin-right: 8px
      svg
        width: auto
        width: 60px
    &__icon, &__radio
      margin-bottom: 0
    &__name
      margin-bottom: 3px
    &__price, &__name, &__pricespan
      font-size: 14px
    &__price, &__oldprice
      text-align: left
    &__oldprice
      font-size: 12px
    &__text, &__uppertext
      font-size: 12px
      min-height: initial
      padding: 8px 8px 4px

</style>